<template>
    <section class="pda-default">
        <div class="mdc-card mdc-elevation--z3 pdb-16" v-if="completionData">
            <div class="t-subtitle2 mgt-16 mgl-16 mgr-16">
                {{$t('685')}}
                <!-- 수료정책 -->
            </div>
            <div class="mgt-30">
                <div class="d-flex flex-row align-content-center pdt-16 mgl-8 mgr-8">
                    <div class="pdl-8 pdr-8">
                        <img src="@/assets/progress_icon.svg" class="w-24 h-24">
                    </div>
                    <div class="pdl-8 pdr-8 flex-grow-1 align-self-center">
                        {{$t('686')}}
                         <!-- 진도율 -->
                    </div>
                    <div class="pdl-8 pdr-8 align-self-center">
                        {{$t('687', {str: completionData.minRate})}}
                        <!-- {{completionData.minRate}}% -->
                    </div>
                </div>
            </div>

            <div class="mgt-16">
                <div class="d-flex flex-row align-content-center pdt-16 mgl-8 mgr-8">
                    <div class="pdl-8 pdr-8">
                        <img src="@/assets/test_icon.svg" class="w-24 h-24">
                    </div>
                    <div class="pdl-8 pdr-8 flex-grow-1 align-self-center">
                        {{$t('688')}}
                        <!-- 정규평가 -->
                    </div>
                    <div class="pdl-8 pdr-8 align-self-center">
                        {{$t(completionData.examScoreType.translate)}}
                        {{$t('689', {str: completionData.examScore})}}
                        <!-- 점 -->
                    </div>
                </div>
            </div>

            <div class="mgt-16 mgb-9">
                <div class="d-flex flex-row align-content-center pdt-16 mgl-8 mgr-8">
                    <div class="pdl-8 pdr-8">
                        <img src="@/assets/parti_icon.svg" class="w-24 h-24">
                    </div>
                    <div class="pdl-8 pdr-8 flex-grow-1 align-self-center">
                        {{$t('690')}}
                        <!-- 참여율 -->
                    </div>
                    <div class="pdl-8 pdr-8 align-self-center">
                        {{$t('691', {str: completionData.minRate})}}
                    </div>
                </div>
            </div>
        </div>

        <div class="mdc-card mdc-elevation--z3 mgt-15 pdb-16" v-if="pointData">
            <div class="t-subtitle2 mgt-16 mgl-16 mgr-16 d-flex flex-row justify-content-between">
                {{$t('692')}}
                <!-- 수료 포인트 -->
                <div class="t-body1">
                    {{$t('693', {str: $n(pointData.earnPoint)})}}
                </div>
            </div>
        </div>

        <div class="mdc-card mdc-elevation--z3 mgt-16 pdb-16" v-if="badgesData.length">
            <div class="t-subtitle2 mgt-16 mgl-16 mgr-16">
                {{$t('694')}}
                <!-- 배지 -->
            </div>
            <div v-for="(badge, index) in badgesData" :key="index">
                <div class="d-flex flex-row align-content-center pdt-16 mgl-8 mgr-8">
                    <div class="pdl-8 pdr-8">
                        <img :src="badge.image" v-if="badge.image" class="badge">
                    </div>
                    <div class="pdl-8 pdr-8 flex-grow-1 align-self-center">
                        {{badge.name}}
                    </div>
                </div>
            </div>

            
        </div>

        
    </section>
</template>

<script>
/**
 * 차수 상세 라워드 탭 컴포넌트(degree view reward tab component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import degreeApi from '@/api/degreeApi.js'

export default {
    data() {
        return {
            completionData: null,
            pointData: null,
            badgesData: []
        }
    },

    mounted() {
        this.fetchData()
    },

    methods: {
        // 리워드정보 API 호출 및 데이터 설정(call api data)
        fetchData() {
            let responseData = null
            let params = this.setParams()

            // 수료조건(Completion)
            degreeApi.guestLearnOnlineViewCompletion(params).then((response) => {
                this.completionData = response.data.data
                
            }).catch((err) => {})

            // 포인트(point)
            degreeApi.guestLearnOnlineViewPoint(params).then((response) => {
                this.pointData = response.data.data
            }).catch((err) => {})

            // 배지(badge)
            degreeApi.guestLearnOnlineViewBadges(params).then((response) => {
                this.badgesData = response.data.data
            }).catch((err) => {})
        },
        
        // 파라미터 설정(set parameter)
        setParams() {
            const params = {
                degreeId: this.$route.params.degreeId
            }
            return params
        },
    }
}
</script>